<template lang="pug">
  .add-wa-form
    y-dialog(fill-height fluid v-model="showModal" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ $t('checkout_form') }}

        v-card-text.pa-0
          v-form(ref="form")
            div.pa-4
              p.h6.basic1000--text.mt-5.mb-1 {{ $t('data_collection') }}
              p.mb-0.p2.primary400--text {{ $t('customer_explain') }}
              v-card.mt-4(outlined)
                  v-simple-table(fixed-header)
                    template(v-slot:default)
                      thead
                        tr
                          th.text-left.basic200.primary400--text.pr-1.pl-3 {{ $t('customer_info') }}
                          th.text-center.basic200.primary400--text.px-1 {{ $t('include') }}
                          th.text-center.basic200.primary400--text.px-1 {{ $t('required') }}
                          th.text-center.basic200.primary400--text.px-3(v-if="extraFields.length != 0") {{ $t('actions') }}
                      tbody
                        tr
                          td.py-2.pr-1.pl-3
                            div.p2.primary--text {{ selectedLang.nameLabel }}
                          td.px-1(align="center")
                            v-row(no-gutters justify="center")
                              v-col.shrink
                                y-checkbox.mb-n2(v-model="customerName" hide-details readonly disabled)
                          td.px-1
                            v-row(no-gutters justify="center")
                              v-col.shrink
                                y-checkbox.mb-n2(v-model="customerName" hide-details readonly disabled)
                          td.pl-1(v-if="extraFields.length != 0")

                        tr
                          td.py-2.pr-1.pl-3
                            div.p2.primary--text {{ selectedLang.phoneLabel }}
                          td.px-1
                            v-row(no-gutters justify="center")
                              v-col.shrink
                                y-checkbox.mb-n2(v-model="customerPhone" hide-details readonly disabled)
                          td.px-1
                           v-row(no-gutters justify="center")
                              v-col.shrink
                                y-checkbox.mb-n2(v-model="customerPhone" hide-details readonly disabled)
                          td.pl-1(v-if="extraFields.length != 0")

                        tr
                          td.py-2.pr-1.pl-3
                            div.p2.primary--text {{ selectedLang.emailLabel }}
                          td.px-1
                            v-row(no-gutters justify="center")
                              v-col.shrink
                                y-checkbox.mb-n2(v-model="customerEmail" hide-details)
                          td.px-1
                            v-row(no-gutters justify="center")
                              v-col.shrink
                                y-checkbox.mb-n2(v-model="emailIsRequired" hide-details :disabled="!customerEmail")
                          td.pl-1(v-if="extraFields.length != 0")

                      draggable.extra-fields(v-model="extraFields" handle=".handle" tag="tbody" @start="drag=true"  @end="drag=false")
                        template(v-for="(extraField, fieldIndex) in extraFields")
                          extra-form-field(:key="extraField.name + fieldIndex" :field="extraField" :index="fieldIndex" @deleted="handleDeleteItem" @edited="handleFieldEdited" :settings.sync="settings")

                      tbody
                        tr
                          td(:colspan="extraFields.length > 0 ? '4' : '3'" style="height: 40px; border-top: thin solid rgba(0, 0, 0, 0.12);")
                            div(align="center")
                              v-btn.button-Aa-small.custom-transform-class.text-none(color="textColorAccent" text @click="showAddExtraDialog = true" small)
                                v-icon.mr-2(color="textColorAccent" size="17") mdi-plus
                                | {{ $t('collect_extra_info') }}
                        
              div.d-flex.align-center.mt-3
                  div.mr-2.p2.primary500--text {{ $t('use_checkout') }}
                  v-menu(left :offset-y='true')
                    template(v-slot:activator='{ on }')
                      v-chip.px-3(color="basic300" small label v-on="on")
                        div.button-AA-tiny.primary--text.text-uppercase {{ getFormLanguageDisplay() }}
                        v-icon.ml-1(right small) mdi-chevron-down
                    v-list
                      v-list-item.my-n2(v-for="(language, index) in languages" :key="language.id" @click="formLanguage = language.id")
                        v-list-item-title.p2 {{ language.name }}

              //- div.d-flex.align-center.mt-4
              //-   p.h6.basic1000--text.mb-0 {{ $t('whos_selling') }}
              //-   v-spacer
              //-   v-btn(color="primary" icon @click="sales_keyboard = !sales_keyboard" small)
              //-     v-icon(color="primary") {{ sales_keyboard ? 'mdi-keyboard-outline' : 'mdi-keyboard-off-outline' }}

              //- .who-selling.mt-2
              //-   p.mb-1.label.basic600--text.text-uppercase Sellers*
              //-   v-combobox.mt-2(v-model="members" background-color="basic200" outlined dense hide-selected hide-no-data hide-details multiple chips placeholder="Select sellers" ref="selectMembers" :search-input.sync="memberSearch" :loading="memberSearchLoading" :items="memberList" :item-text="getMemberSearchText" :rules="rules.not_empty" :menu-props="({ 'closeOnContentClick': false, 'maxHeight': sales_keyboard ? '35%' : '45%' })" :type="sales_keyboard ? 'text' : 'button'")
              //-     template(v-slot:selection="{ attrs, item, select, selected }")
              //-       v-chip.s2.mb-1(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`" v-bind="attrs" outlined small close :color="item.status === 'inactive' ? 'danger' : 'basic600'" :input-value="selected" @click:close="removeSales(item)" close-icon="mdi-close")
              //-         span {{ item.user.first_name }} {{ item.user.last_name }}{{ item.status === 'inactive' ? ' (inactive)' : '' }}
              //-     template(v-slot:item="{ index, item }")
              //-       v-layout
              //-         intel-avatar.mr-3(:code="item.user.avatar_code" :id="item.user.id" size=48)
              //-         v-list-item-content
              //-           v-list-item-title(v-text="item.user.first_name + ' ' + item.user.last_name + (item.status === 'inactive' ? ' (inactive)' : '')")
              //-           v-list-item-subtitle(v-text="item.role")

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-medium.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="clickSave" :loading="isLoading")
            .button-AA-medium.basic100--text(v-if="form") {{ $t('save') }}
            .button-AA-medium.basic100--text(v-else) {{ $t('create') }}

    .modals
      add-wa-extra-field(v-if="showAddExtraDialog" :open.sync="showAddExtraDialog" @added="handleFieldAdded" :settings.sync="settings")
      y-dialog(v-if="showFormExampleDialog" v-model='showFormExampleDialog', scrollable='', max-width='600px')
        v-card
          v-card-title.px-5.primary
            v-row(no-gutters)
              v-col
                p.mb-0.title.white--text {{ $t('form_example') }} ({{ selectedExample }})
              v-col.shrink
                v-btn.mr-n2(text icon @click="showFormExampleDialog = false" height)
                  v-icon(color="white" :size="24") mdi-close
          v-card-text.pt-6
            v-img(v-if="selectedExample == 'card'" :src="require('@/assets/images/waform/wa_example_card.png')")
            v-img(v-if="selectedExample == 'list'" :src="require('@/assets/images/waform/wa_example_list.png')")
            v-img(v-if="selectedExample == 'dropdown'" :src="require('@/assets/images/waform/wa_example_dropdown.png')")
          v-divider
          v-card-actions
            v-spacer
            v-btn(color='grey', text='', @click='showFormExampleDialog = false') {{ $t('close') }}

</template>

<script>
import { mapActions } from 'vuex'
import ExtraFormField from '@/components/ExtraFormField.vue'
import AddWaExtraField from '@/components/dialogs/AddWaExtraField.vue'
import IntelAvatar from '@/components/IntelAvatar.vue'
import draggable from 'vuedraggable'

export default {
  name: 'YezzaStoreForm',
  props: ['open', 'company', 'form', 'settings'],
  components: { ExtraFormField, AddWaExtraField, IntelAvatar, draggable },
  data: () => ({
    items: [{ text: 'Dropdown (single selection)', value: 'dropdown' }, { text: 'Card (multiple selection)', value: 'card' }, { text: 'List (multiple selection)', value: 'list' }, { text: 'Inquiry (no products)', value: 'inquiry' }],
    formName: 'Yezza Store',
    formSlug: '',
    customerName: true,
    customerPhone: true,
    customerEmail: false,
    emailIsRequired: false,
    showAddExtraDialog: false,
    showDeleteFieldDialog: false,
    showFormExampleDialog: false,
    extraField: {
      name: '',
      type: 0,
      required: true,
      enabled: true,
    },
    extraFields: [],
    formLanguage: 'en',
    products: '',
    productSearch: null,
    productSearchLoading: false,
    productList: [],
    seledtedStyle: 'dropdown',
    isLoading: false,
    // members: [],
    // memberSearch: null,
    // memberSearchLoading: false,
    // memberList: [],
    languages: [
      { name: 'English', id: 'en' },
      { name: 'Bahasa Malaysia', id: 'ms' },
      { name: 'Bahasa Indonesia', id: 'id' },
      { name: 'Chinese', id: 'zh' },
      { name: 'Tamil', id: 'ta' }
    ],
    langLabel: [
      {
        id: 'en',
        nameLabel: 'Name',
        phoneLabel: 'Phone',
        emailLabel: 'Email'
      },
      {
        id: 'ms',
        nameLabel: 'Nama',
        phoneLabel: 'No Telefon',
        emailLabel: 'E-mel'
      },
      {
        id: 'id',
        nameLabel: 'Nama',
        phoneLabel: 'Nomor Telepon',
        emailLabel: 'Email'
      },
      {
        id: 'zh',
        nameLabel: '姓名',
        phoneLabel: '电话号码',
        emailLabel: '电子邮件'
      },
      {
        id: 'ta',
        nameLabel: 'பெயர்',
        phoneLabel: 'தொலை பேசி இலக்கம்',
        emailLabel: 'மின் அஞ்சல்'
      }
    ],
    allowBypass: false,
    formType: 'store',
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    },
    prod_keyboard: false,
    sales_keyboard: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    currentForm: {
      get() {
        return this.form
      },
      set(newValue) {
        this.$emit('update:form', newValue)
      }
    },
    selectedLang () {
      return this.langLabel.find(f => f.id === this.formLanguage)
    }
  },
  watch: {
    productSearch () {
      if (this.productList.length != 0) {
        return
      }
      this.startSearchProducts()
    },
    // memberSearch () {
    //   if (this.memberList.length != 0) {
    //     return
    //   }
    //   this.startSearchMembers()
    // },
    showFormExampleDialog (val) {
      if (!val) {
        setTimeout(() => {
          this.openLayoutSelect()
        }, 50)
      }
    },
  },
  mounted () {
    // this.startSearchMembers()
    this.formName = this.form.name
    this.formSlug = this.form.slug
    this.customerEmail = this.form.email_enabled
    this.emailIsRequired = this.form.email_required
    if (this.form.extra_fields) {
      this.extraFields = this.form.extra_fields
    }
    this.formLanguage = this.form.language || 'en'
    this.formType = this.form.type
    if (this.form.type == 'both') {
      this.allowBypass = true
    }
    this.products = this.form.products
    this.seledtedStyle = this.form.layout
    this.$axios.get(`/forms/${this.form.id}/`)
      .then((response) => {
        this.products = response.data.products
        // this.members = response.data.members
        this.formName = response.data.name
        this.formSlug = response.data.slug
        this.customerEmail = response.data.email_enabled
        this.emailIsRequired = response.data.email_required
        if (response.data.extra_fields) {
          this.extraFields = response.data.extra_fields
        }
      })
      .catch(() => {})
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickShowFormExample (value) {
      this.showFormExampleDialog = true
      this.selectedExample = value
    },
    getFormLanguageDisplay () {
      const selectedLanguage = this.languages.filter((obj) => {
        return obj.id == this.formLanguage
      })
      if (selectedLanguage.length > 0) {
        return selectedLanguage[0].name
      }
      return this.formLanguage
    },
    updateFormType () {
      if (this.allowBypass) {
        this.formType = 'both'
      } else {
        this.formType = 'whatsapp'
      }
    },
    startSearchProducts() {
      this.productSearchLoading = true
      this.$axios.get(`/products/?page_size=-1&company=${this.company.id}&ordering=-id`)
        .then(resp => {
          this.productList = resp.data.results
        })
        .catch(() => {})
        .finally(() => (this.productSearchLoading = false))
    },
    // startSearchMembers() {
    //   this.memberSearchLoading = true
    //   this.$axios.get(`/members/?page_size=-1&company=${this.company.id}`)
    //     .then(resp => {
    //       this.memberList = resp.data.results
    //     })
    //     .catch(() => {})
    //     .finally(() => (this.memberSearchLoading = false))
    // },
    getSearchText (item) {
      return item.name + ' ' + item.description
    },
    // getMemberSearchText (item) {
    //   return item.user.first_name + ' ' + item.user.last_name + ' ' + item.user.email
    // },
    handleDeleteItem (index) {
      this.extraFields.splice(index, 1)
    },
    handleFieldAdded (field) {
      this.extraFields.push(field)
    },
    handleFieldEdited (field, index) {
      this.extraFields[index] = field
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        if (!this.formName) {
          this.showMessage(['error', this.$t('error_message.form_name_required')])
        }
        // if (this.members.length === 0) {
        //   this.showMessage(['error', "Seller is required"])
        // }
        return
      }
      this.isLoading = true
      // var memberIds = []
      // this.members.forEach(item => {
      //   if (item.id) {
      //     memberIds.push(item.id)
      //   }
      // })
      if (this.products.length == 0) {
        this.seledtedStyle = 'inquiry'
      }
      const params = {
        company : this.company.id,
        name : this.formName,
        // slug : this.formSlug,
        email_enabled : this.customerEmail,
        email_required : this.emailIsRequired,
        layout : this.seledtedStyle,
        extra_fields : this.extraFields,
        language: this.formLanguage,
        type: this.formType,
        // members: memberIds
      }
      if (this.extraFields != 0) {
        params['extra_fields'] = this.extraFields
      }
      var productIds = []
      if (this.products.length != 0) {
        this.products.forEach(item => {
          if (item.id) {
            productIds.push(item.id)
          }
        })
        params['products'] = productIds
      }
      this.axios.put(`/forms/${this.form.id}/`, params)
      .then(resp => {
        this.currentForm = resp.data
        this.showModal = false
        this.showMessage(['success', this.$t('success_message.form_updated')])
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    openLayoutSelect () {
      const clickEvent = new MouseEvent('click', {
        'view': window,
        'bubbles': true,
        'cancelable': false
      })
      this.$refs.layoutSelect.$refs.input.dispatchEvent(clickEvent)
    },
    removeProd (item) {
      let index = this.products.map(m => { return m.id}).indexOf(item.id)
      if (index >= 0) this.products.splice(index, 1)
    },
    // removeSales (item) {
    //   let index = this.members.map(m => { return m.id}).indexOf(item.id)
    //   if (index >= 0) this.members.splice(index, 1)
    // }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "customer_explain": "Check or add any extra information that should appear on your customer form.",
    "use_checkout": "Use Checkout Form in"
  },
  "id": {
    "customer_explain": "Cek atau tambah informasi lainnya yang perlu tampil dalam form pelanggan.",
    "use_checkout": "Guna Checkout Form pada"
  }
}
</i18n>
